module.exports = __webpack_public_path__ + "static/media/hotelios_ikonka.f8a677fe.svg";